const UiMeet3dLevel = {
  NONE: 0,
  MULTI_USER: 1,
  CHAT: 2,
  VIDEO: 3,
};

export default UiMeet3dLevel;
